var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorporate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M190 258h86v119h-86z",
    fill: "#107988",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.447 305.872c-11.576-11.499-18.796-27.397-18.796-44.992 0-21.145 10.349-39.975 26.349-51.55V92H127v285h47V249.999c0-4.245 3.735-7.999 7.98-7.999h101.327c4.245 0 7.693 3.754 7.693 7.999v85.893c10-13.737 23.318-24.387 39.447-30.02zM278.754 189H186.61c-4.245 0-7.717-3.178-7.717-7.5 0-4.244 3.472-7.5 7.717-7.5h92.144c4.245 0 7.717 3.256 7.717 7.5 0 4.322-3.472 7.5-7.717 7.5zm0-41H186.61c-4.245 0-7.717-3.756-7.717-8s3.472-8 7.717-8h92.144c4.245 0 7.717 3.756 7.717 8s-3.472 8-7.717 8zM53 377h59V134.472l-59 15.666zM413 209.252v-59.114l-59-15.666v66.677c6-2.47 14.181-3.859 21.821-3.859 13.891 0 26.179 4.476 37.179 11.962z",
    fill: "#107988",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.429,
    cy: 260.909,
    r: 48.221,
    fill: "#107988",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.014 318.613c-.154-.54-.154-1.613-.154-1.613h-14.818s0 .995-.154 1.613l-1.18 5.287c-.018-.003-.037-.023-.055-.026l-8.334 37.946L374.217 377h.016l1.218 1.158 1.213-1.158h.022l15.82-15.114-.014-.096.014.013z",
    fill: "#107988",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m398.472 316.984 10.021 45.687c.617 2.623-.238 5.402-2.167 7.254l-25.547 24.386c-1.544 1.39-3.397 2.161-5.326 2.161s-3.86-.772-5.326-2.16l-25.545-24.387a7.537 7.537 0 0 1-2.238-7.254l10.057-45.687C318.677 319.223 292 347.314 292 381.655V420h167v-38.345c0-34.342-26.726-62.432-60.528-64.67z",
    fill: "#107988",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporate);
export default __webpack_public_path__ + "static/media/corporate.4fa9be66cbb4eb42032a9b92f9999f16.svg";
export { ForwardRef as ReactComponent };